module.exports = __webpack_public_path__ + "static/media/logoEgshop-small.1043154c.svg";